import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';

// app: components
import AlacarteOffer from 'components/AlacarteOffer';
import Heading from 'components/Heading';
import MembershipBenefits from 'components/MembershipBenefits';

// app modules: hooks
import useFeatureToggle from 'hooks/useFeatureToggle';

// assets
import CssAlacartePromo from './AlacartePromo.scss';

function AlacartePromo(props) {
  const { className, isbn } = props;
  useStyles(CssAlacartePromo);
  const isOwned = useSelector(state => state.user.owned_books.includes(isbn));
  const loggedIn = useSelector(state => state.user.logged_in);
  const [alacarteEnabled] = useFeatureToggle('alacarte');

  if (isOwned || !alacarteEnabled) {
    return null;
  }
  return (
    <div className={classNames('alc-promo', className)}>
      <AlacarteOffer isbn={isbn} className="margin-bottom-20" />
      <Heading className="margin-left-20">About à la carte books on ckbk</Heading>
      <MembershipBenefits
        type={loggedIn ? 'alacarte-member' : 'alacarte-nonmember'}
        itemClassName="margin-bottom-5"
      />
    </div>
  );
}

AlacartePromo.propTypes = {
  className: PropTypes.string,
  isbn: PropTypes.string.isRequired,
};

AlacartePromo.defaultProps = {
  className: null,
};

export default AlacartePromo;
